// components/CreditHistory.jsx
// src/components/subscription/MembershipInfo.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
// import { getAuthHeader } from '../../utils/authToken';
import { PLAN_CONFIGS } from './config/constants';
// import { formatCurrency } from '../../utils/currency';
import { formatCurrency } from '../../../utils/currency';

// import ConfirmationDialog from './ConfirmationDialog';
import ConfirmationDialog from '../../restaurants/ConfirmationDialog';
import { format } from 'date-fns'; // If using date-fns

import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 5000,
});
const CreditHistory = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
    type: '',
  });

  const fetchTransactions = async () => {
    try {
      const token = localStorage.getItem('ownerToken');
      const params = new URLSearchParams({
        page: currentPage,
        ...filters,
      });

      const response = await api.get(`/credit/history?${params}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTransactions(response.data.transactions);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error('Error fetching credit history:', error);
      toast.error('Failed to load credit history');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [currentPage, filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
    setCurrentPage(1);
  };

  return (
    <div className='container mx-auto px-4 py-8'>
      <h2 className='text-2xl font-bold mb-6'>Credit History</h2>

      {/* Filters */}
      <div className='mb-6 flex flex-wrap gap-4'>
        <input
          type='date'
          name='startDate'
          value={filters.startDate}
          onChange={handleFilterChange}
          className='border p-2 rounded'
        />
        <input
          type='date'
          name='endDate'
          value={filters.endDate}
          onChange={handleFilterChange}
          className='border p-2 rounded'
        />
        <select
          name='type'
          value={filters.type}
          onChange={handleFilterChange}
          className='border p-2 rounded'
        >
          <option value=''>All Types</option>
          <option value='subscription_renewal'>Subscription Renewal</option>
          <option value='credit_purchase'>Credit Purchase</option>
          <option value='message_sent'>Message Sent</option>
          {/* Add other types */}
        </select>
      </div>

      {/* Transactions Table */}
      <div className='overflow-x-auto'>
        <table className='min-w-full bg-white'>
          <thead>
            <tr>
              <th className='px-6 py-3 border-b'>Date</th>
              <th className='px-6 py-3 border-b'>Type</th>
              <th className='px-6 py-3 border-b'>Description</th>
              <th className='px-6 py-3 border-b'>Credits</th>
              <th className='px-6 py-3 border-b'>Balance</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((transaction) => (
              <tr key={transaction._id}>
                <td className='px-6 py-4 border-b'>
                  {new Date(transaction.createdAt).toLocaleDateString()}
                </td>
                <td className='px-6 py-4 border-b'>{transaction.type}</td>
                <td className='px-6 py-4 border-b'>
                  {transaction.description}
                </td>
                <td className='px-6 py-4 border-b'>
                  <span
                    className={
                      transaction.amount > 0 ? 'text-green-600' : 'text-red-600'
                    }
                  >
                    {transaction.amount > 0 ? '+' : ''}
                    {transaction.amount}
                  </span>
                </td>
                <td className='px-6 py-4 border-b'>
                  {transaction.balance.total}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className='flex justify-center mt-6'>
          {/* Add pagination buttons */}
        </div>
      )}
    </div>
  );
};

export default CreditHistory;

// // src/components/subscription/MembershipInfo.jsx
// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// // import { getAuthHeader } from '../../utils/authToken';
// import { PLAN_CONFIGS } from './config/constants';
// // import { formatCurrency } from '../../utils/currency';
// import { formatCurrency } from '../../../utils/currency';

// // import ConfirmationDialog from './ConfirmationDialog';
// import ConfirmationDialog from '../../restaurants/ConfirmationDialog';
// import { format } from 'date-fns'; // If using date-fns

// import axios from 'axios';

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
//   timeout: 5000,
// });
// const CreditHistory = () => {
//   const [transactions, setTransactions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     totalPages: 1,
//     totalTransactions: 0,
//   });

//   const formatDateTime = (timestamp) => {
//     // Using date-fns
//     return format(new Date(timestamp), 'MMM d, yyyy h:mm a');

//     // Or using native JavaScript
//     // const date = new Date(timestamp);
//     // return date.toLocaleString('en-US', {
//     //   year: 'numeric',
//     //   month: 'short',
//     //   day: 'numeric',
//     //   hour: 'numeric',
//     //   minute: 'numeric',
//     //   hour12: true
//     // });
//   };

//   useEffect(() => {
//     fetchTransactions(1);
//   }, []);

//   const fetchTransactions = async (page) => {
//     try {
//       const token = localStorage.getItem('ownerToken');
//       const response = await api.get(`/credit/history?page=${page}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setTransactions(response.data.transactions);
//       setPagination({
//         currentPage: response.data.currentPage,
//         totalPages: response.data.totalPages,
//         totalTransactions: response.data.totalTransactions,
//       });
//     } catch (error) {
//       console.error('Error fetching credit history:', error);
//       toast.error('Failed to load credit history');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className='container mx-auto px-4 py-8'>
//       <h2 className='text-2xl font-bold mb-6'>Credit History</h2>

//       {loading ? (
//         <div>Loading...</div>
//       ) : (
//         <>
//           {/* <div className='bg-white shadow overflow-hidden sm:rounded-lg'> */}
//           <div className='overflow-x-auto'>
//             {/* <table className='min-w-full divide-y divide-gray-200'> */}
//             <table className='min-w-full divide-y divide-gray-200'>
//               <thead className='bg-gray-50'>
//                 <tr>
//                   <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
//                     Date
//                   </th>
//                   <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
//                     Type
//                   </th>
//                   <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
//                     Credits
//                   </th>
//                   <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
//                     Description
//                   </th>
//                 </tr>
//               </thead>
//               {/* <tbody className='bg-white divide-y divide-gray-200'> */}
//               <tbody className='bg-white divide-y divide-gray-200'>
//                 {transactions.map((transaction) => (
//                   <tr key={transaction._id}>
//                     <td className='px-6 py-4 whitespace-nowrap'>
//                       {/* {new Date(transaction.createdAt).toLocaleDateString()} */}
//                       {formatDateTime(transaction.createdAt)}
//                     </td>
//                     <td className='px-6 py-4 whitespace-nowrap'>
//                       <span
//                         className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
//                           transaction.type === 'debit'
//                             ? 'bg-red-100 text-red-800'
//                             : 'bg-green-100 text-green-800'
//                         }`}
//                       >
//                         {transaction.type === 'debit' ? 'Used' : 'Added'}
//                       </span>
//                     </td>
//                     <td className='px-6 py-4 whitespace-nowrap'>
//                       {transaction.type === 'debit' ? '-' : '+'}
//                       {transaction.amount}
//                     </td>
//                     <td className='px-6 py-4'>{transaction.description}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* Pagination */}
//           <div className='mt-4 flex justify-between items-center'>
//             <button
//               onClick={() => fetchTransactions(pagination.currentPage - 1)}
//               disabled={pagination.currentPage === 1}
//               className='px-4 py-2 border rounded disabled:opacity-50'
//             >
//               Previous
//             </button>
//             <span>
//               Page {pagination.currentPage} of {pagination.totalPages}
//             </span>
//             <button
//               onClick={() => fetchTransactions(pagination.currentPage + 1)}
//               disabled={pagination.currentPage === pagination.totalPages}
//               className='px-4 py-2 border rounded disabled:opacity-50'
//             >
//               Next
//             </button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };
// export default CreditHistory;
